import * as React from "react";
import { observer, inject } from "mobx-react";
import { Link } from "react-router-dom";

import LoadingWidget from "../common/LoadingWidget";
import { SessionStore } from "../../stores/SessionStore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKey, faUser } from "@fortawesome/free-solid-svg-icons";

import "src/components/auth/Login.css";

export interface Props {
    sessionStore?: SessionStore;
    history?: any;
}
export interface State {
    username: string;
    password: string;
    errorMessage: string;
    isLoading: boolean;
    wasValidated: boolean;
}

@inject("sessionStore")
@observer
export class Login extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            username: "",
            password: "",
            errorMessage: "",
            isLoading: false,
            wasValidated: false
        };
    }

    handleChange(e: React.FormEvent<HTMLInputElement>): void {
        const value = e.currentTarget.value;
        const name = e.currentTarget.name;
        const state = this.state;
        state[name] = value;
        this.setState(state);
    }

    submit(e: React.FormEvent<HTMLFormElement>): void {
        e.preventDefault();
        if (this.state.isLoading === false) {
            this.setState({ isLoading: true, wasValidated: true });
            this.props
                .sessionStore!.login(this.state.username, this.state.password)
                .catch(err => this.setState({ errorMessage: "Cannot login. Please check your Email Address and Password.", isLoading: false }));
        } else {
            this.setState({ isLoading: true });
        }
    }

    render() {
        return (
            <div className="background-image">
                <div className="login-form col-12 col-sm-12 col-sm-12 col-md-10 col-lg-8 col-xl-5">
                    <div className="row">
                        <div className="login-form-left col-12 col-sm-12 col-md-6">
                            <img src={process.env.PUBLIC_URL + "/images/logo.png"} alt="London Selected Yearling Sale" className="logo" />
                            <p className="info">
                                Western Fair District <br /> London, Ontario
                            </p>
                        </div>
                        <div className="login-form-right col-12 col-sm-12 col-md-6">
                            {this.state.isLoading && <LoadingWidget />}

                            <form
                                onSubmit={e => this.submit(e)}
                                className={"needs-validation" + (this.state.wasValidated ? " was-validated" : "")}
                                noValidate={true}
                            >
                                {!!this.state.errorMessage && (
                                    <div className="alert alert-danger" role="alert">
                                        Cannot login. Please check your Username and Password.
                                    </div>
                                )}

                                <div className="form-group">
                                    <label htmlFor="username">Username</label>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <div className="input-group-text">
                                                <FontAwesomeIcon icon={faUser} />
                                            </div>
                                        </div>
                                        <input
                                            value={this.state.username}
                                            onChange={e => this.handleChange(e)}
                                            name="username"
                                            type="text"
                                            className="form-control"
                                            id="username"
                                            aria-describedby="emailHelp"
                                            placeholder="Username"
                                            required={true}
                                            disabled={this.state.isLoading}
                                        />
                                        <div className="invalid-feedback">Please provide a valid username.</div>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="exampleInputPassword1">Password</label>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <div className="input-group-text">
                                                <FontAwesomeIcon icon={faKey} />
                                            </div>
                                        </div>
                                        <input
                                            value={this.state.password}
                                            onChange={e => this.handleChange(e)}
                                            name="password"
                                            type="password"
                                            className="form-control"
                                            id="exampleInputPassword1"
                                            placeholder="Password"
                                            required={true}
                                            disabled={this.state.isLoading}
                                        />
                                        <div className="invalid-feedback">Please provide a valid password.</div>
                                    </div>
                                    {/* <Link to="/forgot-password" className="form-forgot-password-link">Forgot your Password?</Link> */}
                                </div>
                                <button type="submit" className="btn btn-primary btn-block">
                                    Log In
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/auth/Login.tsx